module.exports = __webpack_public_path__ + "static/media/mac_screen_2.c0a7916d.jpg";